import { Globe, Sparkles, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Field, INPUT_CLS } from "./ChipInput";

export const StepIdentify = ({ data, patch, job, busy, onNext }) => {
  const canContinue = (data.website || "").trim().length > 3 || (data.products || "").trim().length > 10;

  return (
    <div className="space-y-6" data-testid="onboarding-step-identify">
      <div>
        <h2 className="text-2xl text-white font-light">Show me your website — I&apos;ll draft your ideal customer profile.</h2>
        <p className="text-gray-400 mt-2 text-sm">I read your site, work out what you sell and who buys it, then you confirm. Takes about a minute.</p>
      </div>

      <Field label="Company website">
        <div className="relative">
          <Globe className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500" />
          <input value={data.website} onChange={(e) => patch({ website: e.target.value })} placeholder="yourcompany.com" className={`${INPUT_CLS} pl-12 text-lg`} autoFocus data-testid="onboarding-website-input" />
        </div>
      </Field>

      <Field label="Company name" hint="Optional — I'll pick it up from the site if you leave it blank">
        <input value={data.companyName} onChange={(e) => patch({ companyName: e.target.value })} placeholder="Acme Capital" className={INPUT_CLS} data-testid="onboarding-company-input" />
      </Field>

      <details className="group" open={!!(data.products || "").trim()}>
        <summary className="text-sm text-gray-400 cursor-pointer hover:text-white list-none flex items-center gap-2">
          <span className="text-ism-teal">No website yet?</span> Describe what you sell instead
        </summary>
        <textarea value={data.products} onChange={(e) => patch({ products: e.target.value })} rows={3} placeholder="We provide outsourced CFO services to venture-backed startups…" className={`${INPUT_CLS} mt-3 resize-none`} data-testid="onboarding-products-input" />
      </details>

      {job ? (
        <div className="rounded-xl border border-ism-teal/20 bg-ism-teal/5 p-4" data-testid="onboarding-analyze-progress">
          <div className="flex items-center gap-3 text-sm text-white"><Loader2 className="h-4 w-4 animate-spin text-ism-teal" /> {job.stage}…</div>
          <div className="mt-3 h-1.5 bg-white/10 rounded-full overflow-hidden"><div className="h-full bg-ism-teal transition-all duration-500" style={{ width: `${job.progress}%` }} /></div>
        </div>
      ) : (
        <Button onClick={onNext} disabled={!canContinue || busy} className="w-full h-12 bg-ism-teal hover:bg-ism-teal/90 text-black font-medium rounded-xl" data-testid="onboarding-analyze-btn">
          <Sparkles className="h-4 w-4 mr-2" /> Analyze my business
        </Button>
      )}
    </div>
  );
};
